<section class="workspace">
    <h1 class="title" appBottomTransitionReveal>Espacio de trabajo</h1>

    <div class="workspace-content">
        <!-- Consulta -->
        <div class="consulta" appFadeInReveal>
            <div class="photo-container">
                <img src="/consulta.webp" alt="Consulta" class="photo photo--mask" fetchpriority="high"
                    decoding="async" />
                <div class="photo-overlay">
                    <p>Un espacio tranquilo y acogedor</p>
                </div>
            </div>
            <h2>Consulta</h2>
        </div>

        <!-- Sala de espera -->
        <div class="espera" appFadeInReveal>
            <div class="photo-container">
                <img src="/espera.webp" alt="Sala de espera" class="photo photo--mask" fetchpriority="high"
                    decoding="async" />
                <div class="photo-overlay">
                    <p>Un entorno sencillo y acogedor, diseñado para ofrecerte calma desde que llegas</p>
                </div>
            </div>
            <h2>Sala de espera</h2>
        </div>
    </div>
</section>